import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// Fully separate axios instance from services/api.js — own token key
// (affiliateToken, never token) and own 401 redirect target, so a User
// session and an Affiliate session never bleed into each other client-side
// either (mirrors the server-side separation in affiliateAuth.js).
const affiliateApi = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

affiliateApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('affiliateToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

affiliateApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response?.status === 401 && !window.location.pathname.includes('/affiliate/login')) {
      localStorage.removeItem('affiliateToken');
      localStorage.removeItem('affiliateUser');
      window.location.href = '/affiliate/login';
    }
    return Promise.reject(error);
  }
);

export const affiliateAuthAPI = {
  login: (data) => affiliateApi.post('/affiliate-auth/login', data),
  forgotPassword: (data) => affiliateApi.post('/affiliate-auth/forgot-password', data),
  resetPassword: (data) => affiliateApi.post('/affiliate-auth/reset-password', data),
};

// Public, unauthenticated — reused here so the earnings calculator (Phase 10)
// doesn't need a whole separate axios instance just for one read-only call.
export const publicPlansAPI = {
  getPlans: () => affiliateApi.get('/public/plans'),
};

export const affiliatePortalAPI = {
  getMe: () => affiliateApi.get('/affiliate-portal/me'),
  requestDeletion: () => affiliateApi.post('/affiliate-portal/delete-account/request'),
  confirmDeletion: (data) => affiliateApi.post('/affiliate-portal/delete-account/confirm', data),
  cancelDeletion: () => affiliateApi.post('/affiliate-portal/delete-account/cancel'),
  updateProfile: (data) => affiliateApi.put('/affiliate-portal/profile', data),
  // multipart: let the browser set the Content-Type (with its boundary) instead of the JSON default
  submitPan: (formData) => affiliateApi.post('/affiliate-portal/pan', formData, { headers: { 'Content-Type': undefined } }),
  // The card is behind the auth header, so it is fetched as a blob and opened locally
  getPanFile: () => affiliateApi.get('/affiliate-portal/pan/file', { responseType: 'blob' }),
  getPayouts: (params) => affiliateApi.get('/affiliate-portal/payouts', { params }),
  getDashboard: () => affiliateApi.get('/affiliate-portal/dashboard'),
  getCommissions: (params) => affiliateApi.get('/affiliate-portal/commissions', { params }),
  getRewards: () => affiliateApi.get('/affiliate-portal/rewards'),
};

export default affiliateApi;
